import { render, staticRenderFns } from "./PartnersTableRow.vue?vue&type=template&id=3809fb1e&scoped=true&"
import script from "./PartnersTableRow.vue?vue&type=script&lang=ts&"
export * from "./PartnersTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersTableRow.vue?vue&type=style&index=0&id=3809fb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809fb1e",
  null
  
)

export default component.exports